import React, { ReactElement, Suspense, lazy } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';

import ContextProvider from 'store';
import MainPage from 'containers/MainPage';
import NotFoundPage from 'containers/NotFoundPage';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';
import ProtectedRoute from './ProtectedRoute';
import styled from 'styled-components';

const LoginPage = lazy(() => import('containers/LoginPage'));
const DashboardPage = lazy(() => import('containers/DashboardPage'));

const ContainerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100vh - 2em);
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 2em);
`;

const Routes = (): ReactElement => (
  <ContextProvider>
    <BrowserRouter>
      <ContainerWrapper>
        <Navbar />
        <Switch>
          {/* Public Routes */}
          <Route exact path="/" component={MainPage} />
          {/* Admin Routes */}
          <Suspense
            fallback={
              <LoaderWrapper>
                <ClipLoader />
              </LoaderWrapper>
            }
          >
            <Route path="/login" component={LoginPage} />
            <ProtectedRoute path="/dashboard" component={DashboardPage} />
          </Suspense>
          {/* Not Found */}
          <Route component={NotFoundPage} />
        </Switch>
        <Footer />
      </ContainerWrapper>
    </BrowserRouter>
  </ContextProvider>
);

export default Routes;
